<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2025-10-13 18:46:25
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2025-10-14 14:26:16
 * @FilePath: \ctms_pcd:\project\app-map\src\view\driver\reportLocation\components\address-info.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="addr-box">
    <div class="gray-box">
      <div class="title">当前定位</div>
      <div class="text">{{ queryParams.address?queryParams.address:'' }} </div>
    </div>
    <van-button round type="warning" class="footer-button"
      :disabled="!mapLoaded || getCenterLoading" @click="submit">确认地址</van-button>
  </div>
</template>

<script>
import { Button, Toast } from 'vant';
export default {
  name: 'dispatch-address-info',
  props: ['mapCenterInfo', 'queryParams', 'mapLoaded', 'getCenterLoading',],
  components: {
    [Button.name]: Button,
    [Toast.name]: Toast,
  },
  methods: {
    submit() {
      console.log('mapCenterInfo',JSON.stringify(this.mapCenterInfo));
      console.log('queryParams',JSON.stringify(this.queryParams));
      console.log('mapLoaded',JSON.stringify(this.mapLoaded));
      console.log('getCenterLoading',JSON.stringify(this.getCenterLoading));
      if(!this.queryParams.latitude||!this.queryParams.longitude ) return Toast('请开启定位后拖动地图获取位置信息~')
      let query = JSON.parse(JSON.stringify(this.queryParams)) 
      query.pageType = 'driverReportLocation'
      window.uni.postMessage({ data: query});
      window.uni.navigateBack({ delta: 1 });
    }
  }
}
</script>

<style scoped lang="scss">
.addr-box {
  box-sizing: border-box;
  position: relative;
  z-index: 99;
  background-color: #FFFFFF;
  padding: 8px 12px;

  .gray-box {
    background: #F8F8F8;
    border-radius: 4px;
    padding: 16px;

    .title {
      font-weight: 500;
      font-size: 18px;
      color: #3D3833;
    }

    .text {
      font-weight: 400;
      font-size: 12px;
      color: #85807B;
      margin-top: 8px;
    }
  }

  .footer-button {
    width: 100%;
    height: 44px;
    padding: 0 24px;
    background: #FFBD2D;
    border-radius: 4px;
    font-size: 16px;
    line-height: 44px;
    margin: 16px 0px 2px 0px;
    border: none;
    color: #FFF;
  }
}
</style>